import { render, staticRenderFns } from "./Drag.vue?vue&type=template&id=2af99dcf"
import script from "./Drag.vue?vue&type=script&lang=js"
export * from "./Drag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af99dcf')) {
      api.createRecord('2af99dcf', component.options)
    } else {
      api.reload('2af99dcf', component.options)
    }
    module.hot.accept("./Drag.vue?vue&type=template&id=2af99dcf", function () {
      api.rerender('2af99dcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Drag/Drag.vue"
export default component.exports